export function useDateFormatter() {
  /**
   * Formatea cadenas YYYY-MM-DD o ISO a DD/MM/YYYY sin desfases de zona horaria.
   * @param {string|Date} dateStr - Cadena de fecha a formatear.
   * @param {boolean} leadingZero - Si true devuelve 01/10/2026, si false 1/10/2026.
   */
  const formatDateDisplay = (dateStr, leadingZero = false) => {
    if (!dateStr) return '--';
    const cleanStr = String(dateStr).split('T')[0].split(' ')[0];
    const parts = cleanStr.split('-');

    if (parts.length !== 3) return dateStr;

    const [year, month, day] = parts;
    const d = leadingZero ? day.padStart(2, '0') : String(Number(day));
    const m = leadingZero ? month.padStart(2, '0') : String(Number(month));

    return `${d}/${m}/${year}`;
  };

  /**
   * Formatea una fecha + hora para sellos de "Impreso el ..." en PDF,
   * en el mismo formato DD/MM/YYYY HH:mm sin depender de Intl (M10).
   * @param {string|Date} [dateValue] - Fecha a formatear (default: hoy).
   * @returns {string} p. ej. "12/09/2026 14:35"
   */
  const formatDateTimeDisplay = (dateValue) => {
    const date = (typeof dateValue === 'undefined' || dateValue === null || dateValue === '')
      ? new Date()
      : (dateValue instanceof Date ? dateValue : new Date(dateValue));
    if (!date || Number.isNaN(date.getTime())) return '--';
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yyyy = date.getFullYear();
    const hh = String(date.getHours()).padStart(2, '0');
    const mi = String(date.getMinutes()).padStart(2, '0');
    return `${dd}/${mm}/${yyyy} ${hh}:${mi}`;
  };

  return {
    formatDateDisplay,
    formatDateTimeDisplay
  };
}